export default "<app-loading-screen></app-loading-screen>\r\n<router-outlet></router-outlet>"